import { Button, Input, SingleSelect } from 'ui-components/src';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Copy = styled.p`
  margin: 0 0 1rem 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.darkGrey};
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FolderSelect = styled(SingleSelect)`
  width: 90%;
`;

export const PathInput = styled(Input)`
  width: 90%;
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.darkGrey};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;

export const ActionButton = styled(Button)`
  min-width: 7rem;
`;
